// Module
var code = "<span><span v-text=\"remaining\" v-show=\"!hide\"></span></span>\n";
// Exports
export default code;